import React, { useEffect, useMemo } from 'react';
import { Typography } from '@mui/material';
import { safelyParseDate } from '@/utils/date';
import { isAfter } from 'date-fns';
import { formatDate } from '@/utils/constants';

const today = new Date();

const DataGridFormattedDate = ({ date, showOverdue = false, includeTime = false }) => {
	const parsedDate = useMemo(() => safelyParseDate(date), [date]);

	const overdue = useMemo(() => (parsedDate ? isAfter(today, parsedDate) : false), [parsedDate]);

	return (
		<Typography sx={{ ...(overdue && showOverdue && { color: 'red', fontWeight: 600 }) }}>
			{parsedDate ? formatDate(parsedDate, includeTime) : '-'}
		</Typography>
	);
};

export default DataGridFormattedDate;
